import { publicCity } from "./where/public-city.js";

const LOCATION_PATH = "./where/location.json";

function uniqueParts(parts) {
  return parts.filter(Boolean).filter((part, index, values) => values.indexOf(part) === index);
}

export async function initWhereStatus() {
  const status = document.querySelector("[data-where-status]");
  if (!status) return;

  const place = status.querySelector("[data-where-place]");
  const region = status.querySelector("[data-where-region]");

  try {
    const response = await fetch(`${LOCATION_PATH}?t=${Date.now()}`, { cache: "no-store" });
    if (!response.ok) return;

    const location = publicCity(await response.json());
    if (location.status !== "published" || !location.city) return;

    place.textContent = location.city;
    region.textContent = uniqueParts([location.region, location.country]).join(" · ");
    status.classList.add("is-published");
  } catch {
    // The static fallback keeps the link useful when the status file is unavailable.
  }
}
